module.exports = __webpack_public_path__ + "static/media/lupa.542deef0.svg";